import { Accordion, AccordionBody, AccordionHeader, AccordionItem,
    Form, FormGroup, Input, Label, Row, Col, FormText, Spinner, Button, FormFeedback, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import styles from "./UserProfile.module.scss"
import Breadcrumbs from '../../../global/Components/Breadcrumb/Breadcrumb';
import { useToggle } from '../../../global/utils/hooks/useToggle';
import { useEffect, useState, useRef } from 'react';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import Regions from '../../../global/Components/Regions/Regions';
import Upload from '../../../global/Components/Upload/Upload';
import { Editor } from 'primereact/editor';
import FeedbackList from '../../../global/Components/Feedback/FeedbackList';
import { Toast } from 'primereact/toast';

const  USER_URL = 'api/v1/user';
const CHANGE_PASSWORD_URL= 'api/v1/user/password';
const DEACTIVATE_URL = 'api/v1/user/deactivate';

const EMAIL_REGEX  = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@*#$%]).{8,32}$/;

export default function UserProfile() {
    const apiPrivate = useApiPrivate();
    const toast = useRef(null);

    const [open, setOpen] = useState('1');
    const [isLoading, setIsLoading] = useState(false);

    const [description, setDescription] = useState('');
    // const [nationalCardImage, setNationalCardImage] = useState({src:'', newImage:''});
    const [isSeller, setIsSeller] = useState('no');

    const [user, setUser] = useState({});
    const [firstName, setFirstName, onChangeHandlerFirstName] =useOnChangeHandler('');
    const [lastName, setLastName, onChangeHandlerLastName] = useOnChangeHandler('');
    const [username, setUsername, onChangeHandlerUsername] = useOnChangeHandler('');
    const [email, setEmail, onChangeHandlerEmail] = useOnChangeHandler('');
    const [phone, setPhone, onChangeHandlerPhone] = useOnChangeHandler('');
    const [birthday, setBirthday, onChangeHandlerBirthday] = useOnChangeHandler();
    const [profileImage, setProfileImage, onChangeHandlerProfileImage] = useOnChangeHandler({src:'', newImage:''});
    const [countryId, setCountryId, onChangeHandlerCountryId] = useOnChangeHandler('');
    const [stateId, setStateId, onChangeHandlerStateId] = useOnChangeHandler('');
    const [cityId, setCityId, onChangeHandlerCityId] = useOnChangeHandler('');
    const [address, setAddress, onChangeHandlerAddress] = useOnChangeHandler('');
    const [postalCode, setPostalCode, onChangeHandlerPostalCode] = useOnChangeHandler('');
    const [currentPassword, setCurrentPassword, onChangeHandlerCurrentPassword] = useOnChangeHandler('');
    const [newPassword, setNewPassword, onChangeHandlerNewPassword] = useOnChangeHandler('');
    const [confirmPassword, setConfirmPassword, onChangeHandlerConfirmPassword] = useOnChangeHandler('');
    
    const [validEmail, setValidEmail] = useState(false);
    const [validPassword, setValidPassword] = useState(false);
    const [validConfirmPassword, setValidConfirmPassword] = useState(false);
    
    const [isShowPassword, setIsShoPassword, toggleIsShowPassword] = useToggle(false);
    const [modal, setModal, toggleModal] = useToggle(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }
    
    const toggle = (id) => {
      if (open === id) {
        setOpen('');
      } else {
        setOpen(id);
      }
    }

    const handleImage = (file) => {
        setProfileImage({...profileImage,newImage: file});
      }
      
    // const handlenationalCardImage = (file) => {
    //     setNationalCardImage({...nationalCardImage, newImage: file});
    //   }

    const callUserProfile = async () => {
        setIsLoading(true);

        try{
            const response = await  apiPrivate.get(USER_URL);
            setUser(response.data.data);
            setFirstName(response.data.data.first_name)
            setLastName(response.data.data.last_name)
            setUsername(response.data.data.username);
            setEmail(response.data.data.email);
            setBirthday(response.data.data.birth_date);
            setPhone(response.data.data.phone_number);
            setProfileImage({...profileImage, src:response.data.data.avatar});
            setCountryId(response.data.data.country_id);
            setStateId(response.data.data.state_id);
            setCityId(response.data.data.city_id);
            setAddress(response.data.data.address);
            setPostalCode(response.data.data.postal_code);
            setDescription(response.data.data.description);
            setIsSeller(response.data.data.is_seller);
            // setNationalCardImage({...nationalCardImage, src: response.data.data.file_url})
            setIsLoading(false);
        }
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message);
            } 
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }

    const handleSelectRegions = (selected) => {
        setCountryId(selected['country_id']);
        setStateId(selected['state_id']);
        setCityId(selected['city_id']);
      }

    const changePasswordHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try{
            const response = await apiPrivate.put(CHANGE_PASSWORD_URL,JSON.stringify(
                {
                    current_password:currentPassword,
                    password: newPassword,
                    password_confirmation: confirmPassword
                }
            ));
            if(response.data.success){
                showSuccess(response.data.message);
            }
            setIsLoading(false);
        }
        catch (error) {
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message);
            }         
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }
    }
   
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
      
        const formData = new FormData(event.currentTarget);
        formData.append('country_id', countryId ? countryId : '');
        formData.append('state_id', stateId ? stateId : '' );
        formData.append('city_id', cityId ? cityId : '');
        formData.append('description', description);

        formData.append('_avatar', profileImage.newImage[0] ? profileImage.newImage[0] : '');
        // formData.append('_file_url', nationalCardImage.newImage[0] ? nationalCardImage.newImage[0] : '');
     
        try
        {
            const response = await apiPrivate.post(USER_URL, formData,{
                headers: {
                    'content-type': "multipart/form-data",  
                }
            })
            if(response?.status === 200){
                showSuccess('Updated Successfully');
                callUserProfile();
            }
            setIsLoading(false);
        }
        catch(error){
            if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
                showError(error?.response?.data?.message);
            } 
            setIsLoading(false);
        }
        finally{
            setIsLoading(false);
        }

    }

    const handleSellerCheck = (e) => {
        const { checked } = e.target;

        if(checked) {
            setIsSeller('yes');
        } else {
            setIsSeller('no')
        }
    }

    const handleDeactivateClick = async (id) => {
        await apiPrivate.put(DEACTIVATE_URL)
            .then(function(response){
                toggleModal();
                showSuccess(`Your account has been successfully deactivated`);
            })
            .catch(function(error){
                showError('Failed');
            })
          
        }

    useEffect(() => {
        callUserProfile();
    },[]);

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(email));
      },[email]);
    
      useEffect(() => {
        setValidPassword(PASSWORD_REGEX.test(newPassword));
        setValidConfirmPassword(newPassword === confirmPassword)
      },[newPassword,confirmPassword]);
    

      const renderHeader = () => {
        return (
          <span className="ql-formats">
            <button className="ql-bold" aria-label="Bold"></button>
            <button className="ql-italic" aria-label="Italic"></button>
            <button className="ql-underline" aria-label="Underline"></button>
            <select className="ql-align" defaultValue={'left'}>
              <option></option>
              <option value="right"></option>
              <option value="center"></option>
            </select> 
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>                         
          </span>
        );
    };
  
    const header = renderHeader();
  

  return (
    <>
        <Breadcrumbs />
        <Toast ref={toast} position="top-center" />

        <Modal isOpen={modal} toggle={toggleModal}>
            <ModalHeader>
                Deactivate:{' '}{username}
            </ModalHeader>
            <ModalBody>
                Are you sure you want to close the 
                <span className='fw-bold'>
                    {' '}{username}{' '}
                </span>
                account?
                If you click yes, your account will be permanently deactivated.
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={() => handleDeactivateClick()}>
                    Yes
                </Button>{' '}
                <Button color="secondary" onClick={toggleModal}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>

        <Accordion open={open} toggle={toggle} className='mb-3'>
            <AccordionItem>
                <AccordionHeader targetId="1">
                    <i className='bi bi-person me-2 big text-primary'></i>
                    <span className='fw-bold'>
                        Account details
                    </span>
                </AccordionHeader>
                {
                isLoading 
                  ? (
                    <div className='d-flex'>
                       <Spinner color='primary' className='mx-auto my-2 text-center justify-content-center'>
                            Loading...
                        </Spinner>
                    </div>
                  )
                  : (
                <AccordionBody accordionId="1">
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col sm={12} md={4}>
                                <FormGroup floating>
                                    <Input
                                        id="user-name"
                                        name="username"
                                        value={username}
                                        placeholder="username"
                                        type="text"
                                        disabled
                                    />
                                    <Label for="user-name">
                                        Username
                                    </Label>
                                    <FormText>
                                        Username cannot be changed
                                    </FormText>
                                </FormGroup>  
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col sm={12} md={6}>
                                <FormGroup check inline className='mb-3'>
                                    <Label check className='fw-semibold'>
                                        Checked if you want to become a seller
                                    </Label>
                                    <Input
                                    type="checkbox"
                                    checked={isSeller === 'yes'}
                                    onChange={(e) => handleSellerCheck(e)}
                                    />
                                </FormGroup>
                                {
                                    isSeller === 'yes'
                                        && 
                                        <>
                                            <FormGroup>
                                                <Label for="uploadNationalCard" className='fw-semibold mb-0'>
                                                    National Card Image
                                                </Label>
                                            </FormGroup>
                                            <img 
                                                src={`${nationalCardImage.src ? `${process.env.REACT_APP_API_URL}${nationalCardImage.src}` : '/images.png'}`} 
                                                alt='nationalCard-image'
                                                className={`img-fluid img-thumbnail w-50 mb-3`}
                                                />
                                            <FormGroup>
                                                <Upload 
                                                    id="uploadNationalCard"
                                                    name="_file_url"
                                                    accept="image/jpeg, image/png, image/jpg, image/jpe"
                                                    required={false}
                                                    handleImages={handlenationalCardImage}
                                                    mode={true} 
                                                    multiple={false} 
                                                    />
                                                    <FormText>
                                                        Accept Format: .jpeg, .jpg, jpe, .png
                                                    </FormText>
                                            </FormGroup>
                                        </>
                                }
                                
                            </Col>
                        </Row> */}
                        <Row>
                                <Col sm={12} md={4}> 
                                    <FormGroup floating>
                                        <Input
                                            id="first-name"
                                            name="first_name"
                                            value={firstName || ""}
                                            onChange={onChangeHandlerFirstName}
                                            placeholder="First name"
                                            type="text"
                                        />
                                        <Label for="first-name">
                                            First name
                                        </Label>
                                    </FormGroup>   
                                </Col>
                            <Col sm={12} md={4}> 
                                <FormGroup floating>
                                    <Input
                                        id="last-name"
                                        name="last_name"
                                        value={lastName || ""}
                                        onChange={onChangeHandlerLastName}
                                        placeholder="Last name"
                                        type="text"
                                    />
                                    <Label for="last-name">
                                        Last name
                                    </Label>
                                </FormGroup>   
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={6}>
                                <FormGroup floating>
                                    <Input
                                        id ="email"
                                        name='email'
                                        value ={email}
                                        placeholder ='Email'
                                        type ='email'
                                        onChange ={onChangeHandlerEmail}
                                        invalid = { !validEmail ? true :false }
                                        />
                                        <FormFeedback tooltip>
                                            Recipient name.<br />
                                            @ symbol.<br />
                                            Domain name.<br />
                                            Top-level domain.
                                        </FormFeedback>
                                        <Label>
                                            Email
                                        </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                        <Col sm={12} md={6}>
                                <FormGroup floating>
                                    <Input
                                        id ="phone"
                                        name="phone_number"
                                        placeholder ='Phone number'
                                        type ='tell'
                                        value={phone || ""}
                                        onChange={onChangeHandlerPhone}
                                        />
                                        <Label>
                                            Phone number
                                        </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                        <Col sm={12} md={6}>
                                <FormGroup floating>
                                    <Input
                                        id ="birthday"
                                        placeholder ='Birthday'
                                        type ='date'
                                        onChange={onChangeHandlerBirthday}
                                        value={birthday || ""}
                                        name='birth_date'
                                        />
                                        <FormFeedback tooltip>
                                            Recipient name.<br />
                                            @ symbol.<br />
                                            Domain name.<br />
                                            Top-level domain.
                                        </FormFeedback>
                                        <Label>
                                            Birthday
                                        </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="uploadImage" className='fw-semibold mb-0'>
                                        Profile image
                                    </Label>
                                </FormGroup>
                                <img 
                                    src={`${profileImage.src ? `${process.env.REACT_APP_API_URL}${profileImage.src}` : '/images.png'}`} 
                                    alt='profile-image'
                                    className={`img-fluid img-thumbnail mb-3 ${styles.profileImage}`}
                                    />
                                <FormGroup>
                                    <Upload 
                                        id="uploadImage"
                                        name="_avatar"
                                        accept="image/jpeg, image/png, image/jpg, image/jpe"
                                        required={false}
                                        handleImages={handleImage}
                                        // mode={true} 
                                        multiple={false} 
                                        />
                                        <FormText>
                                            Accept Format: .jpeg, .jpg, jpe, .png
                                        </FormText>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Regions col={4} handleSelectRegions={handleSelectRegions} countryId={countryId} stateId={stateId} cityId={cityId}/>
                        </Row>
                        <Row>
                            <Col sm={12} md={8}> 
                                <FormGroup floating>
                                    <Input
                                        id="address"
                                        name="address"
                                        value={address || ""}
                                        onChange={onChangeHandlerAddress}
                                        placeholder="Address"
                                        type="text"
                                    />
                                    <Label for="address">
                                        Address
                                    </Label>
                                </FormGroup>   
                            </Col>
                            <Col md={4}>
                                <FormGroup floating>
                                    <Input
                                        id="postal-code"
                                        name="postal_code"
                                        value={postalCode || ""}
                                        onChange={onChangeHandlerPostalCode}
                                        placeholder="Postal code"
                                        type="text"
                                    />
                                    <Label for="postal-code">
                                        Postal code
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                <Label className='d-block mb-2 fw-semibold'>
                                    Description
                                </Label>
                                <Editor 
                                    id='description' 
                                    name='description' 
                                    value={description} 
                                    onTextChange={(e) => setDescription(e.htmlValue)} 
                                    style={{ height: '320px', color: '#212529',size: '16px' }} 
                                    headerTemplate={header}
                                    />
                                    <FormText>
                                        Avoid entering contact information such as: phone, email and address.
                                    </FormText>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Button disabled={!validEmail && true} type='submit'>
                                    {
                                        isLoading 
                                        ? (
                                            <>
                                            <Spinner size="sm">
                                                Loading...
                                            </Spinner>
                                            <span>
                                                {' '}Loading
                                            </span>
                                            </>
                                        )
                                        : 'Save'
                                    }
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </AccordionBody>
                  )
              }
            </AccordionItem>
            <AccordionItem>
                <AccordionHeader targetId="2">
                    <i className='bi bi-lock me-2 big text-primary'></i>
                    <span className='fw-bold'>
                        Change password
                    </span>
                </AccordionHeader>
                <AccordionBody accordionId="2">
                    <Form>
                        <Row>
                            <Col sm={12} md={4}> 
                                <FormGroup floating>
                                    <Input
                                        id="current-password"
                                        name="password"
                                        placeholder="Current Password"
                                        type="password"
                                        value={currentPassword}
                                        onChange={onChangeHandlerCurrentPassword}
                                    />
                                    <Label for="current-password">
                                        Current Password
                                    </Label>
                                </FormGroup>   
                            </Col>
                            <Col sm={12} md={4}> 
                                <FormGroup floating>
                                    <Input 
                                        id ="new-password"
                                        className={`${styles.showPassword}`}
                                        value ={newPassword}
                                        placeholder ='New Password'
                                        type = { !isShowPassword ? "password" : "text"}
                                        required
                                        onChange ={onChangeHandlerNewPassword}
                                        invalid = { newPassword && !validPassword ? true :false }
                                        />
                                        <span className={`${styles.showIcon}`}
                                            onClick={toggleIsShowPassword}
                                            >
                                        <i className={`bi ${!isShowPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                                        </span>
                                        <FormFeedback tooltip>
                                            8 to 32 characters.<br />
                                            Must include uppercase and lowercase letters, a number and a special character.<br />
                                            Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> 
                                            <span aria-label="hashtag"> #</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span> <span aria-label="star sign">*</span>
                                        </FormFeedback>
                                    <Label>
                                        New Password
                                    </Label>
                                </FormGroup>
                            </Col>
                            <Col sm={12} md={4}> 
                                <FormGroup floating>
                                    <Input
                                        id="confirm-password"
                                        name="confirm_password"
                                        placeholder="Confirm password"
                                        type="password"
                                        value={confirmPassword}
                                        onChange={onChangeHandlerConfirmPassword}
                                        valid = { confirmPassword.length > 0 && validConfirmPassword ? true : false }
                                        invalid = { confirmPassword && !validConfirmPassword ? true :false }
                                    />
                                    <Label for="new-password">
                                        Confirm password
                                    </Label>
                                </FormGroup>   
                            </Col>
                            <Col md={12}>
                                <Button
                                    disabled={!validPassword || !validConfirmPassword || isLoading ? true : false}
                                    onClick={(e) => changePasswordHandler(e)}
                                    >
                                         {
                                            isLoading 
                                            ? (
                                                <>
                                                <Spinner size="sm">
                                                    Loading...
                                                </Spinner>
                                                <span>
                                                    {' '}Loading
                                                </span>
                                                </>
                                            )
                                            : 'Change password'
                                        }
                                    
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </AccordionBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionHeader targetId="4">
                    <i className='bi bi-emoji-smile me-2 big text-primary'></i>
                    <span className='fw-bold'>
                        Feedback
                    </span>
                </AccordionHeader>
                <AccordionBody accordionId="4">
                    {user.id &&
                        <FeedbackList userId={user.id} deleteBtn={true} />
                    }
                </AccordionBody>
            </AccordionItem>
            <AccordionItem>
                <AccordionHeader targetId="3">
                    <i className='bi bi-person-x me-2 big text-primary'></i>
                    <span className='fw-bold'>
                        Deactivate account
                    </span>
                </AccordionHeader>
                <AccordionBody accordionId="3">
                    <p>
                        If you click the deactivate button, your account will be permanently deactivated.
                    </p>
                    <Button 
                        onClick={toggleModal} 
                        size='sm'>
                        <i className="bi bi-x-lg me-2 text-danger"></i> 
                        {
                            isLoading 
                            ? (
                                <>
                                <Spinner size="sm">
                                    Loading...
                                </Spinner>
                                <span>
                                    {' '}Loading
                                </span>
                                </>
                            )
                            : 'DEACTIVATE'
                        }
                    </Button>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    </>
  )
}
